import { InstanceUrl } from "@tento-core/instance-url";
import { PageDecorators } from "./page-decorators";
import { promoPillDecorator } from "./decorators/promo-pill";
import { hydrationBadgeDecorator } from "./decorators/hydration-badge";

// Registers the brand-site decorator plugins. Manifests are cheap (id +
// placement + applies). Bodies are imported eagerly (the brand FE is a bundled
// per-route entry with no import map, so dynamic import() is not used); the
// async load() seam is kept for a future lazy/unbundled path. Called once at app
// boot — must run on every entry that renders a page with decorators.
export function registerBrandDecorators(): void {
  PageDecorators.register({
    id: "lona.promo-pill",
    // Overlaid on top of the hero (absolute, no layout space) so it never shifts
    // the page when it attaches post-hydration.
    placement: { kind: "overlay" },
    // Marketing homepage on the bare root domain only. Service subdomains
    // (blog/static/admin/…) are excluded via InstanceUrl.isRootDomain(), so the
    // product promo pill never shows on e.g. the blog index — which is also
    // served at route "/" but on the blog subdomain. Fleet host prefixes (dev,
    // rwc-01, aws-04) still count as the root domain.
    applies: (page) => page.route === "/" && InstanceUrl.isRootDomain(),
    load: () => Promise.resolve(promoPillDecorator),
  });

  PageDecorators.register({
    id: "lona.hydration-badge",
    placement: { kind: "overlay" },
    applies: () =>
      new URLSearchParams(window.location.search).has("hydration-badge"),
    load: () => Promise.resolve(hydrationBadgeDecorator),
  });

}
